// Packages
import { createAsyncThunk } from '@reduxjs/toolkit';
// API
import { UnbilledHoursApi } from 'api/endpoints';
// Interfaces and types
import { IGetUnbilledHoursRes } from 'types/unbilledHoursTypes';
import { IErrorRes, TQueryParams } from 'types/appTypes';

const getUnbilledHoursAsync = createAsyncThunk<
  IGetUnbilledHoursRes,
  TQueryParams,
  { rejectValue: IErrorRes }
>('unbilledHours/getUnbilledHours', async (params: TQueryParams, { rejectWithValue }) => {
  try {
    return await UnbilledHoursApi.getUnbilledHours(params);
  } catch (error) {
    return rejectWithValue(error as IErrorRes);
  }
});

export { getUnbilledHoursAsync };
